import { render, staticRenderFns } from "./AvgTimeOutflow.vue?vue&type=template&id=2c3fd9e6&scoped=true"
import script from "./AvgTimeOutflow.vue?vue&type=script&lang=js"
export * from "./AvgTimeOutflow.vue?vue&type=script&lang=js"
import style0 from "./AvgTimeOutflow.vue?vue&type=style&index=0&id=2c3fd9e6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3fd9e6",
  null
  
)

export default component.exports